import type { PixelSprite } from '../types.js';
import { sprites as acorn } from './acorn.js';
import { sprites as ancientOak } from './ancientOak.js';
import { sprites as autumnBirch } from './autumnBirch.js';
import { sprites as autumnGinkgo } from './autumnGinkgo.js';
import { sprites as autumnMaple } from './autumnMaple.js';
import { sprites as autumnOak } from './autumnOak.js';
import { sprites as bambooThicket } from './bambooThicket.js';
import { sprites as bareBush } from './bareBush.js';
import { sprites as beehive } from './beehive.js';
import { sprites as berryBush } from './berryBush.js';
import { sprites as birch } from './birch.js';
import { sprites as bird } from './bird.js';
import { sprites as birdhouse } from './birdhouse.js';
import { sprites as butterfly } from './butterfly.js';
import { sprites as butterflyGarden } from './butterflyGarden.js';
import { sprites as cedarGrove } from './cedarGrove.js';
import { sprites as cherryBlossom } from './cherryBlossom.js';
import { sprites as cherryBlossomBranch } from './cherryBlossomBranch.js';
import { sprites as cherryBlossomFull } from './cherryBlossomFull.js';
import { sprites as cherryBlossomSmall } from './cherryBlossomSmall.js';
import { sprites as deadTree } from './deadTree.js';
import { sprites as deciduous } from './deciduous.js';
import { sprites as deer } from './deer.js';
import { sprites as fern } from './fern.js';
import { sprites as fox } from './fox.js';
import { sprites as gardenTree } from './gardenTree.js';
import { sprites as haybale } from './haybale.js';
import { sprites as log } from './log.js';
import { sprites as moss } from './moss.js';
import { sprites as mushroom } from './mushroom.js';
import { sprites as nest } from './nest.js';
import { sprites as owl } from './owl.js';
import { sprites as palm } from './palm.js';
import { sprites as peachBlossom } from './peachBlossom.js';
import { sprites as pine } from './pine.js';
import { sprites as rabbit } from './rabbit.js';
import { sprites as robinBird } from './robinBird.js';
import { sprites as snowDeciduous } from './snowDeciduous.js';
import { sprites as snowPine } from './snowPine.js';
import { sprites as spider } from './spider.js';
import { sprites as squirrel } from './squirrel.js';
import { sprites as stump } from './stump.js';
import { sprites as tallGrass } from './tallGrass.js';
import { sprites as wildflowerMeadow } from './wildflowerMeadow.js';
import { sprites as wildflowerPatch } from './wildflowerPatch.js';
import { sprites as willow } from './willow.js';
import { sprites as winterBird } from './winterBird.js';
export const sprites: Readonly<Record<string, readonly PixelSprite[]>> = {
  acorn,
  ancientOak,
  autumnBirch,
  autumnGinkgo,
  autumnMaple,
  autumnOak,
  bambooThicket,
  bareBush,
  beehive,
  berryBush,
  birch,
  bird,
  birdhouse,
  butterfly,
  butterflyGarden,
  cedarGrove,
  cherryBlossom,
  cherryBlossomBranch,
  cherryBlossomFull,
  cherryBlossomSmall,
  deadTree,
  deciduous,
  deer,
  fern,
  fox,
  gardenTree,
  haybale,
  log,
  moss,
  mushroom,
  nest,
  owl,
  palm,
  peachBlossom,
  pine,
  rabbit,
  robinBird,
  snowDeciduous,
  snowPine,
  spider,
  squirrel,
  stump,
  tallGrass,
  wildflowerMeadow,
  wildflowerPatch,
  willow,
  winterBird,
};
